import getCurrentDateFormat from './getCurrentDayFormat';
export default getCurrentDateFormat;
